// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TestimonialsScore__container___3GWF0{margin:80px 0 0}.TestimonialsScore__inner___22ALA{display:flex;flex-wrap:wrap;justify-content:center;max-width:768px}@media (max-width:959px){.TestimonialsScore__inner___22ALA{grid-template-columns:1fr 1fr;margin:0 auto}}.TestimonialsScore__item___yEHoq{display:flex;flex-direction:column;align-items:center;min-width:230px;margin:40px 0;color:#000;text-decoration:none}.TestimonialsScore__score___1kpKS{font-weight:200;font-size:65px;line-height:80px}.TestimonialsScore__stars___26x_d{display:flex;margin-bottom:15px}.TestimonialsScore__image___3-V_w{height:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "TestimonialsScore__container___3GWF0",
	"inner": "TestimonialsScore__inner___22ALA",
	"item": "TestimonialsScore__item___yEHoq",
	"score": "TestimonialsScore__score___1kpKS",
	"stars": "TestimonialsScore__stars___26x_d",
	"image": "TestimonialsScore__image___3-V_w"
};
module.exports = ___CSS_LOADER_EXPORT___;
